import {
  Button,
  CircularProgress,
} from "@mui/material";
import { COLORS } from "../../STYLES/color";



const ps= {
  //Primary
  bgcolor: "#2E1834",
  color: COLORS.WHITE,
  fontWeight: 500,
  fontSize: "14px",
  borderRadius: "8px",
  height: "44px",
  minWidth: "150px",
  textTransform: "initial",
  boxShadow: "0px 4px 12px 0px #00000026",

  "&:disabled": {
    bgcolor: COLORS.DISABLED,
    color: COLORS.PRIMARY,
    cursor: "not-allowed",
  },
};
const ss= {
  //Secondary
  bgcolor: "#115D31",

  color: "#F7F9F9",
  fontWeight: 500,
  fontSize: "16px",
  borderRadius: "8px",
  height: "50px",
  minWidth: "164px",
  textTransform: "initial",
  
};
const vs= {
  // link
  bgcolor: "transparent",
  fontWeight: 500,
  fontSize: "16px",
  textDecoration: "underline",
  color: "#1F271B",
  ml: -1,
  width: "fit-content",
  textTransform: "initial",
  
};
const fs= {
  //fade
  bgcolor: "#E0FAEB",
  color: "#115D31",
  fontWeight: 600,
  fontSize: "14px",
  borderRadius: "8px",
  minHeight: "50px",
  minWidth: "164px",
  textTransform: "initial",
  fontFamily: "outfit",
  border:'1px solid #115D31'
};
const os= {
  //outlined
  bgcolor: "transparent",
  border: "1px solid #051F10",
  fontWeight: 500,
  color: "#1F271B",
  fontSize: "14px",
  borderRadius: "8px",
  height: "44px",
  minWidth: "164px",
  textTransform: "initial",
  
};
const cs= {
  //cart
  bgcolor: "transparent",
  border: "1px solid #051F10",
  fontWeight: 600,
  color: "#1F271B",
  fontSize: "13px",
  borderRadius: "50px",
  height: "32px",
  minWidth: "110px",
  textTransform: "initial",
  
};

const ds= {
  //danger
  bgcolor: "#9D153F",
  fontWeight: 600,
  color: "#fff",
  fontSize: "12px",
  borderRadius: "8px",
  height: "44px",
  minWidth: "120px",
  textTransform: "initial",
  
};
const MaButton = ({
  title,
  children,
  variant,
  sx,
  loading ,
  ...rest
}) => {
  const load_sx= {
    transition: "0.1s all linear",
    ...(loading && {
      width: "50px",
      p: 1,
      height:"50px",
      minWidth: 0,
      borderRadius: "50%",
    }),
  };

  const variant_style =
    variant === "primary"
      ? ps
      : variant === "secondary"
      ? ss
      : variant === "link"
      ? vs
      : variant === "fade"
      ? fs
      : variant === "cart"
      ? cs
      : variant === "danger"
      ? ds
      : os;
  return (
    <>
      <div className=" flex items-center justify-center">
        <Button
          className="button"
          sx={{ ...variant_style, ...load_sx, ...sx }}
          {...rest}
        >
          {loading ? (
            <CircularProgress size={30} sx={{ color: "inherit" }} />
          ) : (
            <>{children || title}</>
          )}
        </Button>
      </div>
    </>
  );
};

export default MaButton;
